export enum TokenCategoriesEnum {
  SETTING = "setting",
  CUSTOM = "custom",
  USER = "user",
  REPORT = "report",
  THG = "thg",
  PARTNER = "partner",
  BILLING = "billing",
  FORM = "form",
  REQUEST = "request",
  SIGN = "sign",
  URL = "url",
  MY = "my",
  APPRAISAL = "appraisal",
  RENTAL = "rental",
  ESTIMATE = "repairEstimate",
  CLEARANCE_APPROVAL = "clearanceApproval",
  CLEARANCE = "clearance"
}
